import React from 'react'

import { createValidIcon } from '@ui/icons/utils/type-helper'

export const NewspaperIcon = createValidIcon((props) => {
  const { size, color } = props

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M20 9C20 8.44772 19.5523 8 19 8H18V18C18 18.5523 18.4477 19 19 19C19.5523 19 20 18.5523 20 18V9ZM13 15C13.5523 15 14 15.4477 14 16C14 16.5523 13.5523 17 13 17H7C6.44772 17 6 16.5523 6 16C6 15.4477 6.44772 15 7 15H13ZM13 7C13.5523 7 14 7.44772 14 8V12C14 12.5523 13.5523 13 13 13H7C6.44772 13 6 12.5523 6 12V8C6 7.44772 6.44772 7 7 7H13ZM8 11H12V9H8V11ZM16 6C16 5.44771 15.5523 5 15 5H5C4.44772 5 4 5.44772 4 6V18C4 18.5523 4.44772 19 5 19H16.1738C16.0631 18.6869 16 18.351 16 18V6ZM19 6C20.6569 6 22 7.34315 22 9V18C22 19.6569 20.6569 21 19 21H5C3.34315 21 2 19.6569 2 18V6C2 4.34314 3.34315 3 5 3H15C16.6569 3 18 4.34314 18 6H19Z'
        fill={color}
      />
    </svg>
  )
})
